export const getApiUrl = (endpoint: string): string => {
    const baseUrl = process.env.NEXT_PUBLIC_BACKEND_URL || "";
    const finalUrl = `${baseUrl}/api${endpoint}`;
    return finalUrl;
};
